import React from 'react';
import '../styles/LoveLetter.css'; // Import CSS for styling
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import LlCard from '../components/LlCard';

const LoveLetter = () => {
    const reasons = [
        "Your smile lights up my world and makes me instantly happy.",
        "You always know how to make me laugh even when I'm feeling down.",
        "Our late-night talks are my favorite (even when they go until 7am).",
        "You encourage me to be the best version of me, and make me want to be the best version of me.",
        "Every moment with you feels magical like if cats ruled the government with hats.",
        "You make me feel safe and loved which is all I ever want.",
        "Our inside jokes are the best.",
        "You’re my partner in every adventure, even if you won't always gallop with me.",
        "Your kindness and compassion inspires me every day and makes me want to be nicer to people.",
        "I love the way you look at me. Even when you won't tell me what the look means.",
        "You make even the most simple and boring tasks and errands feel special and fun.",
        "You are the best human I know and I am so so lucky to have you in my life.",
        "I love every moment we spend together, even one of us isn't 100% it's always comforting and warm.",
        "Our cuddles are unmatched!",
    ];

    const memories = [
        { img: "/memories/memory1.jpg", text: "The only photo I have of our first 'proper' date at 111 by Modu." },
        { img: "/memories/memory2.jpg", text: "My first time properly visiting you at work (and getting made a proper drink)." },
        { img: "/memories/memory3.jpg", text: "That time you lost poker. Again." },
        { img: "/memories/memory4.jpg", text: "When you found a sad dead crab during our visit to Culzean Castle." },
        { img: "/memories/memory5.jpg", text: "I love our visits to the gym and I can't wait until I'm stronger than you x." },
        { img: "/memories/memory6.jpg", text: "The first of your birthdays that we celebrated together." },
        { img: "/memories/memory7.jpg", text: "I love this photo of you tipsy at Crabshakk." },
        { img: "/memories/memory8.jpg", text: "Our first proper hike together. You did not look pleased. BUT WE SAW CUTE DOGS." },
        { img: "/memories/memory9.jpg", text: "The first time I met your family, I was sooo nervous but I had the best time because your family is amazing and they raised an amazing son." },
        { img: "/memories/memory10.jpg", text: "Cuddling in bed with you and working on our Sims obsession." },
        { img: "/memories/memory11.jpg", text: "A little shopping spree with my favorite shopping donkey." },
        { img: "/memories/memory12.jpg", text: "You weren't having a great day here but you still took the time to take photos in the sunbeam with me and they turned out sooo well." },
        { img: "/memories/memory13.png", text: "The ingrediends we used to make our first ever dinner party together." },

    ];

    // Combine memories and reasons in an interleaved pattern
    const interleavedContent = [];
    let memoryIndex = 0;
    let reasonIndex = 0;

    while (memoryIndex < memories.length || reasonIndex < reasons.length) {
        // Add one memory card
        if (memoryIndex < memories.length) {
            interleavedContent.push({ type: 'memory', content: memories[memoryIndex] });
            memoryIndex++;
        }

        // Add one or two reason cards
        if (reasonIndex < reasons.length) {
            interleavedContent.push({ type: 'reason', content: reasons[reasonIndex] });
            reasonIndex++;
        }
    }

    return (
        <div className="love-letter-container">
            {/* Background Music */}
            <audio autoPlay loop>
                <source src={'/audio/soft-music.mp3'} type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>

            {/* Floating Hearts */}
            <div className="floating-hearts">
                {[...Array(20)].map((_, index) => (
                    <img
                        key={index}
                        src={'/heart.png'}
                        alt="heart"
                        className="floating-heart"
                        style={{
                            left: `${Math.random() * 100}vw`,
                            animationDelay: `${Math.random() * 5}s`,
                        }}
                    />
                ))}
            </div>

            {/* Scrolling Content */}
            <div className="scrolling-masonry">
                <ResponsiveMasonry>
                    <Masonry>
                        {interleavedContent.map((item, index) => (
                            <LlCard key={index} type={item.type} content={item.content} index={index} />
                        ))}
                    </Masonry>
                </ResponsiveMasonry>
            </div>
        </div>
    );
};

export default LoveLetter;